import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})
export class ExamService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewExam() {
    return this.http.get(this.baseurl + '/api/Exams/GetExams')
  }

  addExam(examForm) {
    console.log(examForm);
    return this.http.post(this.baseurl+'/api/Exams', examForm)
  }

  reGenerateExam(examSysref) {
    return this.http.get(this.baseurl + '/api/Exams/ReGenerateExam?examSysref=' + examSysref);
  }

  editExam(id, examForm) {
    console.log(examForm);
    return this.http.put(this.baseurl+`/api/Exams/${id}`, examForm)
  }

  deleteExam(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Exams/${id}`)
  }
}
